import { __awaiter } from "tslib";
import CpuAction from "../CpuAction";
export default class SetALUOperation extends CpuAction {
    constructor() {
        super();
        this._name = "SetALUOperation";
    }
    action(ctx) {
        return __awaiter(this, void 0, void 0, function* () {
            const operation = ctx.cpu.model.instructionRegister.get().opcode.operator;
            ctx.cpu.model.aluOperation.set(operation);
            yield ctx.cpu.component.flash("ALU:OPR");
        });
    }
}
